import backpack from '~/assets/icons/backpack_2.svg';
import compass from '~/assets/icons/compass.svg';
import question from '~/assets/icons/question.svg';
import shop from '~/assets/icons/shop.svg';
import stats from '~/assets/icons/stats.svg';
import task from '~/assets/icons/task_2.svg';

import { useMemo } from 'react';
import { rage, useInputAction, useObservable } from '~/rage';
import { InputAction } from '~/shared';
import { useMenuLocked } from '../../hooks';
import {
	setIsOpeningCase,
	setShopKitOpen,
	setShopOpenCaseVisible,
	setShopPlayerItemsOpen,
	setTabIndexNext,
	setTabIndexPrev,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import { Tab } from '../Tab';
import { TabButton } from '../TabButton';
import { TabsContainer } from '../TabsContainer';
import { StyledMenuContainer } from './MenuTabs.styled';

const MenuTabs = () => {
	const dispatch = useLayoutDispatch();
	const shopKitOpen = useLayoutSelector((state) => state.shop.shopKitOpen);
	const shopPlayerItemsOpen = useLayoutSelector(
		(state) => state.shop.shopPlayerItemsOpen,
	);
	const shopOpenCaseVisible = useLayoutSelector(
		(state) => state.shop.shopOpenCaseVisible,
	);
	const { menuLocked } = useMenuLocked();
	const cases = useObservable(rage.cases.getLootboxes());
	const bundles = useObservable(rage.cases.getBundles());
	const donateItemsCount = useObservable(rage.inventoryDonate.getItemsCount());

	const shopCount = useMemo(
		() => cases.length + bundles.length + donateItemsCount,
		[cases.length, bundles.length, donateItemsCount],
	);

	const resetShopState = () => {
		if (shopKitOpen) {
			dispatch(setShopKitOpen(false));
		}
		if (shopPlayerItemsOpen) {
			dispatch(setShopPlayerItemsOpen(false));
		}
		if (shopOpenCaseVisible) {
			dispatch(setShopOpenCaseVisible(false));
			dispatch(setIsOpeningCase(false));
		}
	};

	useInputAction(InputAction.CommonTabNavLeft, () => {
		if (menuLocked) {
			return;
		}

		dispatch(setTabIndexPrev());
		resetShopState();
	});
	useInputAction(InputAction.CommonTabNavRight, () => {
		if (menuLocked) {
			return;
		}

		dispatch(setTabIndexNext());
		resetShopState();
	});

	return (
		<StyledMenuContainer>
			<TabButton onClick={() => dispatch(setTabIndexPrev())}>Q</TabButton>
			<TabsContainer>
				<Tab text={'Главная'} icon={compass} />
				<Tab text={'Магазин'} icon={shop} count={shopCount} />
				<Tab text={'Инвентарь'} icon={backpack} />
				<Tab text={'Задачи'} icon={task} />
				<Tab text={'Персонаж'} icon={stats} />
				<Tab text={'Помощь'} icon={question} />
			</TabsContainer>
			<TabButton onClick={() => dispatch(setTabIndexNext())}>E</TabButton>
		</StyledMenuContainer>
	);
};

export { MenuTabs };
